export class SubjectStatus {
}
//# sourceMappingURL=subject-status.js.map